import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import { __awaiter, __decorate, __extends, __generator, __spreadArrays } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { enumData } from '@/decorators';
import PreviewFiles from '@/components/previewFiles/index.vue';
import MulAttrUpload from '@/components/mulAttrUpload/index.vue';

var default_1 = function (_super) {
  __extends(default_1, _super);

  function default_1() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.modalVisible = false;
    _this.lastAvailableSku = undefined;
    _this.productDetails = undefined;
    _this.euroCountryList = [];
    _this.approvedImportCountryList = [];
    _this.availableImportCountryList = [];
    _this.availableExportCountryList = [];
    _this.confirmLoading = false;
    _this.rowCountryList = {};
    _this.rowAppealReasonList = {};
    _this.rowBeforeAppealList = {};
    _this.skuAvailable = false;
    _this.productDetailsImportCountryList = [];
    _this.productDetailsBasicsInfo = {};
    _this.productDetailsExportCountryList = [];
    _this.exceptAppealReasonList = {};
    _this.curIndex = 0;
    _this.fileList = [];
    _this.materialList = [];
    _this.fileTipMessage = '';
    _this.onceAppealReasonList = [_this.$enum.product.AppealReasonEnum.EN_DECLARED_NAME_EDIT, _this.$enum.product.AppealReasonEnum.IMPORT_TARIFF_PCT_EDIT, _this.$enum.product.AppealReasonEnum.CN_DECLARED_NAME_EDIT, _this.$enum.product.AppealReasonEnum.BRAND_EDIT];
    _this.manyAppealReasonList = [_this.$enum.product.AppealReasonEnum.EXPORT_DECLARED_VALUE_EDIT, _this.$enum.product.AppealReasonEnum.IMPORT_DECLARED_VALUE_EDIT, _this.$enum.product.AppealReasonEnum.CN_NAME_EDIT, _this.$enum.product.AppealReasonEnum.EN_NAME_EDIT, _this.$enum.product.AppealReasonEnum.LINK_EDIT, _this.$enum.product.AppealReasonEnum.PURPOSE_EDIT, _this.$enum.product.AppealReasonEnum.MATERIAL_EDIT, _this.$enum.product.AppealReasonEnum.IS_NEED_COMPLIANCE_OFFICER_EDIT, _this.$enum.product.AppealReasonEnum.HEAD_TYPE_EDIT, _this.$enum.product.AppealReasonEnum.IS_OVERSEA_WAREHOUSE_STORABLE, _this.$enum.product.AppealReasonEnum.MODEL_EDIT, _this.$enum.product.AppealReasonEnum.IMAGE_LIST_EDIT];
    _this.importAppealReasonList = [];
    _this.exportAppealReasonList = [];
    _this.headTypeList = [];
    _this.boolEnumList = [];
    _this.form = _this.initFormData();
    _this.countryTypeList = [{
      text: _this.t('common', '进口国'),
      value: _this.$enum.product.ProductCountryTypeEnum.IMPORT
    }, {
      text: _this.t('common', '出口国'),
      value: _this.$enum.product.ProductCountryTypeEnum.EXPORT
    }];
    _this.rules = {};
    return _this;
  }

  Object.defineProperty(default_1.prototype, "isOperationMode", {
    get: function get() {
      return !!this.operationData;
    },
    enumerable: false,
    configurable: true
  });

  default_1.prototype.queryProductMaterialList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, code, data;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            return [4, this.$api.product.queryProductMaterialList()];

          case 1:
            _a = _b.sent(), code = _a.code, data = _a.data;

            if (code === 0) {
              this.materialList = data;
            }

            return [2];
        }
      });
    });
  };

  default_1.prototype.handleUploadFileTipMessage = function (msg) {
    this.fileTipMessage = msg;
  };

  default_1.prototype.initModalData = function () {
    this.form.appeal_list = [this.initAppealItem()];
    this.productDetailsExportCountryList.length = 0;
    this.productDetailsImportCountryList.length = 0;
    this.exceptAppealReasonList = {};
    this.fileList = {};
    this.rowBeforeAppealList = {};
    this.rowCountryList = {};
    this.rowAppealReasonList = {};
    this.lastAvailableSku = '';

    if (this.form.product_sku !== this.lastAvailableSku) {
      this.skuAvailable = false;
    }

    this.approvedImportCountryList.length = 0;
    this.availableExportCountryList.length = 0;
    this.availableImportCountryList.length = 0;
  };

  default_1.prototype.initAppealItem = function () {
    return {
      country_code: '',
      appeal_reason: undefined,
      country_type: undefined,
      after_appeal: '',
      appeal_remark: '',
      attachs: [],
      _image_list: []
    };
  };

  default_1.prototype.handleCountryTypeChange = function (index, value) {
    this.form.appeal_list[index].country_code = '';
    this.form.appeal_list[index].appeal_reason = undefined;
    this.form.appeal_list[index].after_appeal = '';
    this.form.appeal_list[index].appeal_remark = '';
    this.rowBeforeAppealList[index] = '';
    this.computeCountries();
    this.computeCountryReasons();
  };

  default_1.prototype.handleSearchSkuList = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.searchSkuList({
              keyword: value,
              search_original: this.$enum.common.BoolIntEnum.YES,
              is_select_flag: true
            })];

          case 1:
            return [2, _a.sent()];
        }
      });
    });
  };

  default_1.prototype.initFormData = function () {
    return {
      product_sku: '',
      appeal_list: [this.initAppealItem()]
    };
  };

  default_1.prototype.handleCancel = function () {
    this.initModalData();
    this.form = this.initFormData();
    this.lastAvailableSku = undefined;
    this.$refs.formModel.clearValidate();
    this.modalVisible = false;
  };

  default_1.prototype.handleOk = function () {
    return __awaiter(this, void 0, Promise, function () {
      var formModelRef;

      var _this = this;

      return __generator(this, function (_a) {
        formModelRef = this.$refs.formModel;
        formModelRef.validate(function (valid) {
          return __awaiter(_this, void 0, void 0, function () {
            var postData, index, _a, code, message;

            var _this = this;

            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  if (!valid) {
                    return [2];
                  }

                  postData = this.$util.deepCopy(this.form);
                  postData.product_sku = this.form.product_sku.toUpperCase();

                  for (index in this.fileList) {
                    if (postData.appeal_list[index].appeal_reason === this.$enum.product.AppealReasonEnum.HEAD_TYPE_EDIT) {
                      postData.appeal_list[index].attachs = this.fileList[index].map(function (it) {
                        return {
                          file_path: it.file_path,
                          file_name: it.file_name
                        };
                      });
                    }
                  }

                  postData.appeal_list.forEach(function (item) {
                    var _a, _b;

                    if (item.appeal_reason === _this.$enum.product.AppealReasonEnum.IMAGE_LIST_EDIT) {
                      item.before_appeal = JSON.stringify(((_a = _this.productDetails) === null || _a === void 0 ? void 0 : _a.image_list) || []);
                      item.attachs = ((_b = item._image_list) === null || _b === void 0 ? void 0 : _b.map(function (it) {
                        return {
                          file_path: it.path,
                          file_name: it.customer_file_name
                        };
                      })) || [];
                    }
                  });
                  return [4, this.$api.product.addAppeal(postData)];

                case 1:
                  _a = _b.sent(), code = _a.code, message = _a.message;
                  this.confirmLoading = false;

                  if (code === 0) {
                    this.$message.success(this.t('申诉提交成功'));
                    this.modalVisible = false;
                    this.$refs.formModel.clearValidate();
                    this.initModalData();
                    this.form = this.initFormData();
                    this.$emit('success');
                    typeof this.onSuccess === 'function' && this.onSuccess();
                  } else {
                    this.$message.error(message);
                  }

                  return [2];
              }
            });
          });
        });
        return [2];
      });
    });
  };

  default_1.prototype.queryEuroCountryList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var res, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.common.queryBmsCountryList({
              is_euro: true
            })];

          case 1:
            res = _a.sent();
            data = res.data;
            this.euroCountryList = data;
            return [2];
        }
      });
    });
  };

  default_1.prototype.queryAppealList = function () {
    var _a;

    return __awaiter(this, void 0, Promise, function () {
      var postData, data, exceptAppealReasonList, _loop_1, this_1, _i, _b, importCountryItem, _c, data_1, item, _d, _e, appealItem;

      return __generator(this, function (_f) {
        switch (_f.label) {
          case 0:
            postData = {
              product_sku_equal: this.form.product_sku,
              page_index: 1,
              page_size: 9999
            };
            return [4, this.$api.product.queryAppealList(postData)];

          case 1:
            data = _f.sent().data.data;
            exceptAppealReasonList = {};
            exceptAppealReasonList.CN = [];

            _loop_1 = function _loop_1(importCountryItem) {
              if (!exceptAppealReasonList[importCountryItem.country_code]) {
                exceptAppealReasonList[importCountryItem.country_code] = [];
              }

              if (this_1.$enum.product.HeadTypeEnum.GC_FIRST_VESSEL === importCountryItem.head_type) {
                exceptAppealReasonList[importCountryItem.country_code].push(this_1.$enum.product.AppealReasonEnum.HEAD_TYPE_EDIT);
              }

              if (this_1.$enum.common.BoolIntEnum.YES === importCountryItem.is_send) {
                exceptAppealReasonList[importCountryItem.country_code].push(this_1.$enum.product.AppealReasonEnum.IS_OVERSEA_WAREHOUSE_STORABLE);
              }

              if (!this_1.euroCountryList.find(function (item) {
                return importCountryItem.country_code === item.code;
              }) || this_1.$enum.common.BoolIntEnum.NO === importCountryItem.is_send) {
                exceptAppealReasonList[importCountryItem.country_code].push(this_1.$enum.product.AppealReasonEnum.IS_NEED_COMPLIANCE_OFFICER_EDIT);
              }
            };

            this_1 = this;

            for (_i = 0, _b = this.approvedImportCountryList; _i < _b.length; _i++) {
              importCountryItem = _b[_i];

              _loop_1(importCountryItem);
            }

            for (_c = 0, data_1 = data; _c < data_1.length; _c++) {
              item = data_1[_c];

              if (!item.appeal_list || !item.appeal_list.length) {
                continue;
              }

              for (_d = 0, _e = item.appeal_list; _d < _e.length; _d++) {
                appealItem = _e[_d];

                if (!exceptAppealReasonList[appealItem.country_code]) {
                  exceptAppealReasonList[appealItem.country_code] = [];
                }

                if ((_a = exceptAppealReasonList[appealItem.country_code]) === null || _a === void 0 ? void 0 : _a.includes(appealItem.appeal_reason)) {
                  continue;
                }

                if (this.onceAppealReasonList.includes(appealItem.appeal_reason)) {
                  exceptAppealReasonList[appealItem.country_code].push(appealItem.appeal_reason);
                  continue;
                }

                if (this.manyAppealReasonList.includes(appealItem.appeal_reason) && item.appeal_box_status === 2) {
                  exceptAppealReasonList[appealItem.country_code].push(appealItem.appeal_reason);
                  continue;
                }
              }
            }

            this.exceptAppealReasonList = exceptAppealReasonList;
            return [2];
        }
      });
    });
  };

  default_1.prototype.searchSkuList = function (params) {
    return __awaiter(this, void 0, Promise, function () {
      var res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.$api.product.searchSkuList(params, {
              loading: false
            })];

          case 1:
            res = _a.sent();
            return [2, res.data || []];
        }
      });
    });
  };

  default_1.prototype.queryProductDetails = function () {
    return __awaiter(this, void 0, Promise, function () {
      var _a, data, code, importCountries, e_1;

      var _this = this;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            this.initModalData();
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 4]);

            this.lastAvailableSku = this.form.product_sku;
            return [4, this.$api.product.queryProductDetails({
              sku: this.form.product_sku
            }, {
              showError: false
            })];

          case 2:
            _a = _b.sent(), data = _a.data, code = _a.code;
            this.productDetailsBasicsInfo = data.basics_info;
            this.productDetailsImportCountryList = data.import_country_list;
            this.productDetailsExportCountryList = data.export_country_list || [];

            if (this.$enum.product.ProductStatusEnum.AVAILABLE === data.basics_info.product_status && [this.$enum.product.ProducReVerifyStatusEnum.REVIEW_OK, this.$enum.product.ProducReVerifyStatusEnum.APPEAL_OK].includes(data.basics_info.re_verify_status)) {
              this.skuAvailable = true;
              this.approvedImportCountryList = data.import_country_list.filter(function (importCountry) {
                return [_this.$enum.product.ClearanceStatusEnum.PASS, _this.$enum.product.ClearanceStatusEnum.REVIEW_COMPLETED].includes(importCountry.clearance_status);
              });
              importCountries = this.approvedImportCountryList.map(function (item) {
                return {
                  country_code: item.country_code,
                  country_name: item.country_name
                };
              });
              this.availableImportCountryList = __spreadArrays(importCountries);
              this.availableExportCountryList = __spreadArrays(this.productDetailsExportCountryList.map(function (item) {
                return {
                  country_code: item.country_code,
                  country_name: item.country_name
                };
              }));
              return [2, data];
            } else {
              this.skuAvailable = false;
              this.$message.info(this.t('商品状态为可用且复核状态为无需复核的商品才能申诉'));
            }

            return [3, 4];

          case 3:
            e_1 = _b.sent();
            this.skuAvailable = false;
            this.$message.error(this.t('未查询到商品，请重新输入商品编码'));
            return [3, 4];

          case 4:
            return [2];
        }
      });
    });
  };

  default_1.prototype.queryComplianceComplianceOfficerDetail = function (rowIndex) {
    return __awaiter(this, void 0, void 0, function () {
      var countryCode, searchData, res, is_need_compliancer;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            countryCode = this.form.appeal_list[rowIndex].country_code;
            searchData = {
              code_field: this.$enum.product.MaintenanceProductFieldEnum.PRODUCT_SKU,
              code_value: [this.form.product_sku],
              import_country: countryCode
            };
            this.form.appeal_list[rowIndex].after_appeal = undefined;
            this.rowBeforeAppealList[rowIndex] = undefined;
            return [4, this.$api.product.queryMaintenanceComplianceOfficerList(searchData)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              is_need_compliancer = void 0;

              if (!res.data.list[0]) {
                is_need_compliancer = this.$enum.common.BoolIntEnum.NO;
              } else {
                if (res.data.list[0].is_need_compliancer === undefined) {
                  is_need_compliancer = this.$enum.common.BoolIntEnum.NO;
                } else {
                  is_need_compliancer = res.data.list[0].is_need_compliancer;
                }
              }

              this.rowBeforeAppealList[rowIndex] = is_need_compliancer;
              this.form.appeal_list[rowIndex].after_appeal = is_need_compliancer === this.$enum.common.BoolIntEnum.YES ? this.$enum.common.BoolIntEnum.NO : this.$enum.common.BoolIntEnum.YES;
            }

            return [2];
        }
      });
    });
  };

  default_1.prototype.handleAdd = function () {
    var item = this.initAppealItem();
    this.form.appeal_list.push(item);

    if (this.isOperationMode) {
      var len = this.form.appeal_list.length;
      this.computeCountries();
      item.country_code = this.operationData.import_country_code;
      item.country_type = this.operationData.country_type;
      this.handleCountryChange(len - 1, this.operationData.import_country_code);
    } else {
      this.$refs.formModel.clearValidate();
      this.computeCountries();
    }
  };

  default_1.prototype.handleDelete = function (index) {
    this.form.appeal_list.splice(index, 1);
    this.$refs.formModel.clearValidate();
    this.computeCountryReasons();
    this.computeCountries();
    delete this.fileList[index];
  };

  default_1.prototype.handleClear = function () {
    this.initModalData();
    this.form = this.initFormData();
    this.$refs.formModel.clearValidate();
  };

  default_1.prototype.handleCountryChange = function (rowIndex, value) {
    this.form.appeal_list[rowIndex].appeal_reason = undefined;
    this.form.appeal_list[rowIndex].after_appeal = '';
    this.form.appeal_list[rowIndex].appeal_remark = '';
    this.rowBeforeAppealList[rowIndex] = '';
    this.computeCountryReasons();
  };

  default_1.prototype.computeCountries = function () {
    var _loop_2 = function _loop_2(i) {
      var appealItem = this_2.form.appeal_list[i];
      var availableAppealReasonList = this_2.getAvailableAppealReasonList(appealItem.country_type);
      var countryCodeList = [];

      if (!this_2.rowCountryList[i]) {
        this_2.rowCountryList[i] = [];
      }

      if (appealItem.appeal_reason && appealItem.country_code) {
        countryCodeList = [appealItem.country_code];
      }

      for (var countryCode in availableAppealReasonList) {
        if (appealItem.country_code && countryCode !== appealItem.country_code && availableAppealReasonList[countryCode].length || this_2.$util.isEmpty(appealItem.country_code)) {
          countryCodeList.push(countryCode);
        }
      }

      var availableCountryList = appealItem.country_type === this_2.$enum.product.ProductCountryTypeEnum.EXPORT ? this_2.availableExportCountryList : this_2.availableImportCountryList;
      this_2.rowCountryList[i] = availableCountryList.filter(function (item) {
        return countryCodeList.includes(item.country_code);
      });
    };

    var this_2 = this;

    for (var i = 0; i < this.form.appeal_list.length; i++) {
      _loop_2(i);
    }
  };

  default_1.prototype.computeCountryReasons = function () {
    var _this = this;

    var selectedAppealReasonList = this.getSelectedAppealReasonList();

    var _loop_3 = function _loop_3(i) {
      var appealItem = this_3.form.appeal_list[i];
      this_3.rowAppealReasonList[i] = [];

      if (appealItem.country_type === this_3.$enum.product.ProductCountryTypeEnum.EXPORT) {
        this_3.rowAppealReasonList[i] = this_3.exportAppealReasonList.filter(function (appealReason) {
          var _a, _b;

          var value = appealReason.value;

          if (Number(_this.productDetailsBasicsInfo.is_brand) === _this.$enum.common.BoolIntEnum.NO && value === _this.$enum.product.AppealReasonEnum.BRAND_EDIT) {
            return false;
          }

          return !((_a = _this.exceptAppealReasonList[appealItem.country_code]) === null || _a === void 0 ? void 0 : _a.includes(value)) && !((_b = selectedAppealReasonList[appealItem.country_code]) === null || _b === void 0 ? void 0 : _b.includes(value)) || value === appealItem.appeal_reason;
        });
      } else {
        var exceptAppealReasonList_1 = this_3.exceptAppealReasonList[appealItem.country_code];
        this_3.rowAppealReasonList[i] = this_3.importAppealReasonList.filter(function (appealReason) {
          var _a;

          var value = appealReason.value;
          return !(exceptAppealReasonList_1 === null || exceptAppealReasonList_1 === void 0 ? void 0 : exceptAppealReasonList_1.includes(value)) && !((_a = selectedAppealReasonList[appealItem.country_code]) === null || _a === void 0 ? void 0 : _a.includes(value)) || value === appealItem.appeal_reason;
        });
      }
    };

    var this_3 = this;

    for (var i = 0; i < this.form.appeal_list.length; i++) {
      _loop_3(i);
    }
  };

  default_1.prototype.getSelectedAppealReasonList = function () {
    var _a;

    var selectedAppealReasonList = {};

    for (var _i = 0, _b = this.form.appeal_list; _i < _b.length; _i++) {
      var appealItem = _b[_i];

      if (!selectedAppealReasonList[appealItem.country_code]) {
        selectedAppealReasonList[appealItem.country_code] = [];
      }

      if (appealItem.appeal_reason && appealItem.country_code && !((_a = selectedAppealReasonList[appealItem.country_code]) === null || _a === void 0 ? void 0 : _a.includes(appealItem.appeal_reason))) {
        selectedAppealReasonList[appealItem.country_code].push(appealItem.appeal_reason);
      }
    }

    return selectedAppealReasonList;
  };

  default_1.prototype.getAvailableAppealReasonList = function (countryType) {
    var _a, _b;

    var selectedAppealReasonList = this.getSelectedAppealReasonList();
    var availableAppealReasonList = {};

    for (var _i = 0, _c = countryType === this.$enum.product.ProductCountryTypeEnum.EXPORT ? this.availableExportCountryList : this.approvedImportCountryList; _i < _c.length; _i++) {
      var countryItem = _c[_i];

      if (!availableAppealReasonList[countryItem.country_code]) {
        availableAppealReasonList[countryItem.country_code] = [];
      }

      var appealReasonList = countryType === this.$enum.product.ProductCountryTypeEnum.EXPORT ? this.exportAppealReasonList : this.importAppealReasonList;

      for (var _d = 0, appealReasonList_1 = appealReasonList; _d < appealReasonList_1.length; _d++) {
        var appealReason = appealReasonList_1[_d];
        var value = appealReason.value;

        if (!((_a = this.exceptAppealReasonList[countryItem.country_code]) === null || _a === void 0 ? void 0 : _a.includes(value)) && (!selectedAppealReasonList[countryItem.country_code] || !((_b = selectedAppealReasonList[countryItem.country_code]) === null || _b === void 0 ? void 0 : _b.includes(value)))) {
          availableAppealReasonList[countryItem.country_code].push(value);
        }
      }
    }

    return availableAppealReasonList;
  };

  default_1.prototype.handleReasonChange = function (rowIndex, value) {
    this.computeCountryReasons();
    this.form.appeal_list[rowIndex].after_appeal = '';
    var countryCode = this.form.appeal_list[rowIndex].country_code;
    var importData = this.productDetailsImportCountryList.find(function (item) {
      return item.country_code === countryCode;
    });
    var exportData = this.productDetailsExportCountryList.find(function (item) {
      return item.country_code === countryCode;
    });
    var BasicsInfo = this.productDetailsBasicsInfo;

    switch (value) {
      case this.$enum.product.AppealReasonEnum.EN_DECLARED_NAME_EDIT:
        this.rowBeforeAppealList[rowIndex] = importData.customs_clearance_name_en;
        break;

      case this.$enum.product.AppealReasonEnum.HEAD_TYPE_EDIT:
        if (null === importData.head_type || undefined === importData.head_type) {
          this.rowBeforeAppealList[rowIndex] = '';
        } else {
          var headTypeEnum = this.headTypeList.find(function (item) {
            return item.value === importData.head_type;
          });
          this.rowBeforeAppealList[rowIndex] = headTypeEnum.text;
        }

        this.form.appeal_list[rowIndex].after_appeal = this.$enum.product.HeadTypeEnum.GC_FIRST_VESSEL;
        break;

      case this.$enum.product.AppealReasonEnum.EXPORT_DECLARED_VALUE_EDIT:
        this.rowBeforeAppealList[rowIndex] = String(exportData.declared_value);
        break;

      case this.$enum.product.AppealReasonEnum.IMPORT_DECLARED_VALUE_EDIT:
        this.rowBeforeAppealList[rowIndex] = String(importData.declared_value);
        break;

      case this.$enum.product.AppealReasonEnum.IMPORT_TARIFF_PCT_EDIT:
        this.rowBeforeAppealList[rowIndex] = importData.tariff_percentage;
        break;

      case this.$enum.product.AppealReasonEnum.IS_OVERSEA_WAREHOUSE_STORABLE:
        if (null === importData.head_type || undefined === importData.head_type) {
          this.rowBeforeAppealList[rowIndex] = '';
        } else {
          var isSend = this.boolEnumList.find(function (item) {
            return item.value === importData.is_send;
          });
          this.rowBeforeAppealList[rowIndex] = isSend.text;
        }

        this.form.appeal_list[rowIndex].after_appeal = this.$enum.product.HeadTypeEnum.SELLER_DIRECT_SEND;
        break;

      case this.$enum.product.AppealReasonEnum.CN_DECLARED_NAME_EDIT:
        this.rowBeforeAppealList[rowIndex] = exportData === null || exportData === void 0 ? void 0 : exportData.declared_name_cn;
        break;

      case this.$enum.product.AppealReasonEnum.CN_NAME_EDIT:
        this.rowBeforeAppealList[rowIndex] = BasicsInfo.product_name_cn;
        break;

      case this.$enum.product.AppealReasonEnum.EN_NAME_EDIT:
        this.rowBeforeAppealList[rowIndex] = BasicsInfo.product_name_en;
        break;

      case this.$enum.product.AppealReasonEnum.LINK_EDIT:
        this.rowBeforeAppealList[rowIndex] = BasicsInfo.product_url;
        break;

      case this.$enum.product.AppealReasonEnum.BRAND_EDIT:
        this.rowBeforeAppealList[rowIndex] = BasicsInfo.product_brand;
        break;

      case this.$enum.product.AppealReasonEnum.PURPOSE_EDIT:
        this.rowBeforeAppealList[rowIndex] = BasicsInfo.product_function;
        break;

      case this.$enum.product.AppealReasonEnum.MATERIAL_EDIT:
        this.rowBeforeAppealList[rowIndex] = BasicsInfo.product_material;
        break;

      case this.$enum.product.AppealReasonEnum.IS_NEED_COMPLIANCE_OFFICER_EDIT:
        this.queryComplianceComplianceOfficerDetail(rowIndex);
        break;

      case this.$enum.product.AppealReasonEnum.MODEL_EDIT:
        this.rowBeforeAppealList[rowIndex] = BasicsInfo.product_model;
        break;

      default:
        break;
    }
  };

  default_1.prototype.queryDetail = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      var _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!value || this.lastAvailableSku && this.lastAvailableSku === value) {
              return [2];
            }

            _a = this;
            return [4, this.queryProductDetails()];

          case 1:
            _a.productDetails = _b.sent();

            if (!this.skuAvailable) {
              return [2];
            }

            return [4, this.queryAppealList()];

          case 2:
            _b.sent();

            return [2];
        }
      });
    });
  };

  default_1.prototype.handleQuery = function (value) {
    return __awaiter(this, void 0, Promise, function () {
      return __generator(this, function (_a) {
        this.queryDetail(value);
        return [2];
      });
    });
  };

  default_1.prototype.uploadRequest = function (file) {
    return __awaiter(this, void 0, Promise, function () {
      var formData, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            formData = new FormData();
            formData.append('file', file);
            formData.append('file_type', String(this.$enum.product.ProductAttachmentType.APPEAL));
            return [4, this.$api.product.uploadAttachment(formData)];

          case 1:
            data = _a.sent().data;

            if (!this.fileList[this.curIndex]) {
              this.fileList[this.curIndex] = [];
            }

            this.fileList[this.curIndex].push(data);
            this.$forceUpdate();
            return [2];
        }
      });
    });
  };

  default_1.prototype.onOperationDataChange = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!this.operationData) return [3, 2];
            this.form.product_sku = this.operationData.product_sku;
            return [4, this.queryDetail(this.form.product_sku, 0)];

          case 1:
            _a.sent();

            this.form.appeal_list[0].country_code = this.operationData.import_country_code;
            this.form.appeal_list[0].country_type = this.operationData.country_type;
            this.handleCountryChange(0, this.operationData.import_country_code);
            _a.label = 2;

          case 2:
            return [2];
        }
      });
    });
  };

  default_1.prototype.handleImageListChange = function (index, value) {
    this.form.appeal_list[index].after_appeal = JSON.stringify(value);
    this.$refs.formModel.validateField(["appeal_list." + index + ".after_appeal"], function () {});
  };

  default_1.prototype.created = function () {
    var _this = this;

    this.queryEuroCountryList();
    this.queryProductMaterialList();

    var productNameEnValidate = function productNameEnValidate(rule, value, callback) {
      var field = rule.field;
      var index = field.split('.')[1];
      var item = _this.form.appeal_list[index];

      if (item.appeal_reason === _this.$enum.product.AppealReasonEnum.IS_NEED_COMPLIANCE_OFFICER_EDIT) {
        callback();
      }

      if (!value && value !== 0) {
        callback(new Error(_this.t('请输入内容')));
      }

      if (item.appeal_reason === _this.$enum.product.AppealReasonEnum.EN_DECLARED_NAME_EDIT && !/^[\x00-\xff]{1,255}$/.test(value)) {
        callback(new Error(_this.t('请使用英文输入法输入字符')));
      } else if (item.appeal_reason === _this.$enum.product.AppealReasonEnum.LINK_EDIT) {
        var reg = new RegExp('^(?=[^\\.])(?=.*?[\\.])[\\x00-\\xff]{0,999}(?![^\\x00-\\xff])[^\\.]$');

        if (!reg.test(value)) {
          callback(new Error(_this.t('限制 1000 个字符，含.且前后有字符，不能包含中文')));
        } else {
          callback();
        }
      } else if (item.appeal_reason === _this.$enum.product.AppealReasonEnum.IMPORT_TARIFF_PCT_EDIT) {
        if (!/^\d{6,10}$/.test(value)) {
          callback(new Error(_this.t('海关编码的长度为6~10位纯数字')));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    this.rules = {
      product_sku: [{
        required: true,
        type: 'string',
        whitespace: true,
        max: 100,
        message: $t("\u8BF7\u8F93\u5165\u7F16\u7801")
      }],
      'appeal_list.*.after_appeal': [{
        validator: productNameEnValidate
      }]
    };
  };

  __decorate([Prop({
    type: Object,
    "default": function _default() {
      return null;
    }
  })], default_1.prototype, "operationData", void 0);

  __decorate([Prop({
    type: Function,
    "default": function _default() {
      return function () {};
    }
  })], default_1.prototype, "onSuccess", void 0);

  __decorate([enumData('Product/ImportAppealReasonEnum')], default_1.prototype, "importAppealReasonList", void 0);

  __decorate([enumData('Product/ExportAppealReasonEnum')], default_1.prototype, "exportAppealReasonList", void 0);

  __decorate([enumData('Product/HeadTypeEnum')], default_1.prototype, "headTypeList", void 0);

  __decorate([enumData('BoolIntEnum')], default_1.prototype, "boolEnumList", void 0);

  __decorate([Watch('operationData', {
    immediate: true
  })], default_1.prototype, "onOperationDataChange", null);

  default_1 = __decorate([Component({
    components: {
      PreviewFiles: PreviewFiles,
      MulAttrUpload: MulAttrUpload
    }
  })], default_1);
  return default_1;
}(Vue);

export default default_1;